import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { uploadCommonFile, uploadOrderFile } from './actionCreators';
import { initialState, UPLOADS_SLICE_NAME, UploadsState } from './models';

export const slice = createSlice({
  name: UPLOADS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isFulfilled(uploadCommonFile, uploadOrderFile), (state: UploadsState, action) => {
        const { payload } = action;
        state.file = payload;
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(uploadCommonFile, uploadOrderFile), (state: UploadsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(uploadCommonFile, uploadOrderFile), (state: UploadsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;
